export default function fieldValidator(field) {
  let anyFieldError = false;

  const isRequired = field.rules && field.rules.includes('required');
  const isEmail = field.rules && field.rules.includes('email');
  const isNumberic = field.rules && field.rules.includes('numeric');
  const value = field.value || null;

  if (isRequired && !value) {
    anyFieldError = true;
  } else if (isEmail && value) {
    const re = /^[^@]+@[^@]{2,}\.[^@]{2,}$/;
    const validateEmail = re.test(String(value).toLowerCase().trim());

    if (!validateEmail) {
      anyFieldError = true;
    }
  } else if(isNumberic && value){
     if(!/^[0-9]+$/.test(value)){
       anyFieldError = true;
     }
  }

  field.error = anyFieldError;

  return !anyFieldError;
}
